import { cx } from "./controlStyles";

// Keyboard key chip: 20px, 12px sans, hairline border.
interface KbdProps {
  children: React.ReactNode;
  className?: string;
}

export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={cx(
        "inline-grid h-[20px] min-w-[20px] place-items-center rounded-[5px] border border-line px-[5px] font-sans text-xs text-fg-muted",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
